import { client } from './client';
import { AbandonedCart } from 'state/abandoned-cart/types/abandoned-cart';

type EncryptedQuoteLeadId = {
  encryptedID: string;
}

export const postQuoteLead = (
  payload: AbandonedCart
): Promise<EncryptedQuoteLeadId> => {
  return client('quote-lead', {
    method: 'POST',
    body: payload
  });
}

export const patchQuoteLeadById = (
  payload: AbandonedCart,
  encryptedQuoteId:string
): Promise<EncryptedQuoteLeadId> => {
  return client(`quote-lead/${encryptedQuoteId}`, {
    method: 'PATCH',
    body: payload
  });
}

export const getQuoteLeadById = (encryptedQuoteId:string) =>
  client(`quote-lead/${encryptedQuoteId}`, {
    method: 'GET',
  });
